<template>
    <div id="returnPostage">
        <van-cell-group class="form-input">
            <van-field
                v-model.trim="userInfo.oldIccid"
                required
                label="旧卡ICCID："
                placeholder="请输入旧卡ICCID"
                
            />

            <van-field
                v-model.trim="userInfo.newIccid"
                required
                clearable
                label="新卡ICCID："
                
            />

        </van-cell-group>

        <div class="formLine">
            <van-button type="primary" size="small" @click.prevent="returnPostage()">申请退还邮费</van-button> 
        </div>  
    </div>
</template>
<script>
import {wxRequest} from '@/api/user.js' 

export default {
    data(){
        return {
            userInfo: {
                oldIccid: '',
                newIccid: ''
            },
        }        
    },
    created() {
        if(localStorage.getItem("iccid")){
            this.userInfo.newIccid = localStorage.getItem("iccid");
        }
        if(this.$route.query.oldIccid){
            this.userInfo.oldIccid = this.$route.query.oldIccid;
            this.userInfo.newIccid = '';
        }
    },
    methods: {              
        returnPostage(){
            if(this.userInfo.oldIccid==''){
                this.$dialog.alert({title:'提示', message: '请先输入旧卡iccid'});
                return;
            }else if(this.userInfo.newIccid==''){
                this.$dialog.alert({title:'提示', message: '请先输入新卡iccid'});
                return;
            }
            let fd = new FormData();
            fd.append("oldIccid", this.userInfo.oldIccid);
            fd.append("newIccid", this.userInfo.newIccid);
            wxRequest("order/postage/back", fd, "post").then(res => {
                this.$dialog.alert({title:'提示', message: res.data.message});
            })
        }
    },

    mounted(){

    },
}
</script>

<style>

#returnPostage .van-field__body{
    height: 100%;
}

#returnPostage .van-button--small {
    height: 35px;
    width: 96%;
    letter-spacing: 1px;
}
</style>

<style lang="less">
    #returnPostage{
        .formLine{
            display: flex;
            margin-top: 10px;
            justify-content: center;
        }
    }
</style>